import { initReactI18next } from 'react-i18next'
import { createI18nInstance } from 'common-translations/src/vtj/i18next-utils'
import fi from 'todistukset-ui/src/vtj/static/localization_fi.json'
import sv from 'todistukset-ui/src/vtj/static/localization_sv.json'
import en from 'todistukset-ui/src/vtj/static/localization_en.json'
import todistuksetCommonTranslations from 'todistukset-common/src/vtj/localization/todistukset-common.translations'
import commonTranslations from 'common-translations/src/vtj/translations-bundle'

const instance = createI18nInstance({
  defaultBundle: {
    namespace: 'todistukset-ui',
    translations: { fi, sv, en },
  },
  additionalBundles: [todistuksetCommonTranslations, commonTranslations],
  modules: [initReactI18next],
})

export default instance
